import { apiProxyRequest } from "Api/apiProxyRequest";

import type { SshKey } from "./types";

type AddSshKeysRequestProps = { value: string; title: string };

export const addSshKeyRequest = ({ value, title }: AddSshKeysRequestProps) =>
  apiProxyRequest<SshKey>(`/ssh_keys`, "POST", { value, title });
